// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const whirlipede: PokeData = {
  "id": 544,
  "name": "whirlipede",
  "height": 12,
  "weight": 585,
  "base_experience": 126,
  "types": [
    PokeType.BUG,
    PokeType.POISON
  ],
  "api_moves": [
    "take-down",
    "double-edge",
    "poison-sting",
    "toxic",
    "agility",
    "screech",
    "defense-curl",
    "protect",
    "rollout",
    "pursuit",
    "iron-defense",
    "poison-tail",
    "rock-climb",
    "bug-bite",
    "venoshock",
    "steamroller",
    "venom-drench"
  ],
  "moves": [
    "protect",
    "pursuit",
    "bug-bite",
    "venom-drench",
    "purify",
    "leech-steal",
    "poison-fang",
    "poison-powder",
    "sticky-web",
    "pin-missile",
    "pounce",
    "infest",
    "toxic-overload"
  ],
  "evolution_chain": {
    "id": 277,
    "item": null,
    "species": [
      {
        "name": "venipede",
        "order": 544,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "whirlipede",
        "order": 545,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": 543,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 22,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "scolipede",
        "order": 546,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": 544,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 64.5,
    "speed": 47,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
